import React from 'react';

import { ChartRepository } from './ChartRepository';
import { IPropsSongsSettingsDisplay } from './SongsSettingsPanel';

export const SettingChartRepository: React.FC<IPropsSongsSettingsDisplay> = ({
	popDisplayState,
}) => {
	return <ChartRepository onSave={popDisplayState} />;
};
